import { z } from 'zod';
import i18n from '../i18n';

// Messaggi valutati alla creazione dello schema (import time): la lingua è
// fissata al build, e i18n è inizializzato prima di qualunque import dell'app.
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, i18n.t('auth.validazione.email_obbligatoria'))
    .email(i18n.t('auth.validazione.email_formato')),
  password: z
    .string()
    .min(1, i18n.t('auth.validazione.password_obbligatoria'))
    .min(8, i18n.t('auth.validazione.password_min')),
});

export type LoginFormData = z.infer<typeof loginSchema>;
